export interface RankingChartViewItem {
  label: string
  score: number
  rank: number
}

export interface RankingScoreDatum {
  label: string
  score: number
}

/**
 * Map pre-aggregated scores into rank-ordered view items (highest score first).
 * Cache scope: one-shot per render; callers own any memoization.
 */
export function rankingViewItemsFromScores(
  entries: Array<RankingScoreDatum>,
): Array<RankingChartViewItem> {
  return entries
    .filter((entry) => Number.isFinite(entry.score))
    .sort((left, right) => right.score - left.score)
    .map((entry, index) => ({
      label: entry.label,
      score: entry.score,
      rank: index + 1,
    }))
}
